import styled from 'styled-components';

export const CreateTicketSC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;